import menu from './menu.js'
import table from './table.js'

export default {
    name: 'Name',
    statisticSurvey: 'Statistikerhebung',
    type: 'Typ',
    identifier: 'Kürzel',
    identifierHelpText: 'Das Kürzel sollte nur in Rücksprache mit den Entwicklern von //farbcode geändert werden.',
    is_active: 'Aktiv',
    multiple_occurrences_in_survey_period: 'Mehrfach vorkommend im Erhebungszeitraum',

    statisticFormFieldConfig: 'Statistikformularfelderkonfiguration',

    saveSuccess: 'Statistikformular wurde erfolgreich gespeichert.',

    deleteStatisticForm: 'Formular löschen',
    deleteStatisticFormText: 'Möchtest du dieses Formular wirklich löschen?',
    deleteStatisticFormSuccess: 'Formular wurde erfolgreich gelöscht.',
    deleteStatisticFormError: 'Das Formular konnte nicht gelöscht werden.',

    menu,
    table
}